import React, { useState } from "react";
import { menuImages } from './ImagesJson'
import Flip from "./Flip";

const Navbar2 = () => {
    const [activeCategory, setActiveCategory] = useState("All");

    const categories = [
        { name: "All" },
        { name: "Sweets" },
        { name: "Namkeen" },
        { name: "Bevrages" },
        { name: "Season" },
    ];

    return (
        <>
            <div className="nav-buttons">
                {categories.map((category) => (
                    <button
                        key={category.name}
                        className={`nav-button ${activeCategory === category.name ? "navbar-active" : ""
                            }`}
                        onClick={() => setActiveCategory(category.name)}
                    >
                        {category.name}
                    </button>
                ))}
            </div>

            <div className="flip-card-grid">
                {menuImages
                    .filter(
                        (item) => activeCategory === "All" || item.type === activeCategory
                    )
                    .map((item, index) => (
                        <Flip
                            key={index}
                            image={item.src}
                            name={item.name}
                            description={item.description}
                        />
                    ))}
            </div>

        </>
    );
};

export default Navbar2;
